import { render, staticRenderFns } from "./DefaultProductItem.vue?vue&type=template&id=2ae703c8&scoped=true"
import script from "./DefaultProductItem.vue?vue&type=script&lang=js"
export * from "./DefaultProductItem.vue?vue&type=script&lang=js"
import style0 from "./DefaultProductItem.vue?vue&type=style&index=0&id=2ae703c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae703c8",
  null
  
)

export default component.exports